import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import api from "@/api/client";
import ProductCard from "@/components/products/ProductCard";
import { Heart } from "lucide-react";

const Wishlist = () => {
  const { user } = useAuth();
  const [items, setItems] = useState(null);

  useEffect(() => {
    if (!user) return;
    api.get("/wishlist").then((r) => setItems(r.data));
  }, [user]);

  if (!user) return <div className="container-fah py-20 text-center"><Link to="/login" className="text-primary underline">Login</Link> to see your wishlist</div>;

  return (
    <div className="container-fah py-8 sm:py-12" data-testid="page-wishlist">
      <h1 className="font-display text-3xl font-bold mb-6 flex items-center gap-2"><Heart className="w-7 h-7 text-secondary" /> My Wishlist</h1>
      {items === null ? <div className="text-muted-foreground">Loading…</div> : items.length === 0 ? (
        <div className="card-fah p-10 text-center">
          <Heart className="w-12 h-12 mx-auto text-muted-foreground" />
          <h2 className="font-display text-xl mt-3">Your wishlist is empty</h2>
          <p className="text-muted-foreground mt-1">Save your favorite products to view them later.</p>
          <Link to="/products" className="mt-4 inline-block bg-primary text-white font-semibold py-2.5 px-5 rounded-lg">Explore Products</Link>
        </div>
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 sm:gap-6">
          {items.map((p) => <ProductCard key={p.id} product={p} />)}
        </div>
      )}
    </div>
  );
};

export default Wishlist;
